import { render, staticRenderFns } from "./MercadoPagoAccount.vue?vue&type=template&id=609237a0"
import script from "./MercadoPagoAccount.vue?vue&type=script&lang=js"
export * from "./MercadoPagoAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports